import CheckboxGroup from './CheckboxGroup.client'

export default CheckboxGroup
